(function () {
  'use strict';

  const page = (window.FoxTheme && window.FoxTheme.page) || {};

  const STORAGE_KEY = 'seo_internal_links_v1';
  const MAX_LINKS_PER_PAGE = 5;
  const MIN_AFFINITY_SCORE = 0.15;
  const DATA_RETENTION_DAYS = 90;

  // Initialize or load data
  function getData() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return { clicks: {}, lastCleanup: Date.now() };

      const data = JSON.parse(stored);
      // Cleanup old data
      if (Date.now() - data.lastCleanup > 7 * 24 * 60 * 60 * 1000) {
        cleanupOldData(data);
        data.lastCleanup = Date.now();
      }
      return data;
    } catch {
      return { clicks: {}, lastCleanup: Date.now() };
    }
  }

  function saveData(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch {
      // Storage full - cleanup and retry
      cleanupOldData(data);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch {
        console.warn('[Internal Links] Storage failed');
      }
    }
  }

  function cleanupOldData(data) {
    const cutoff = Date.now() - DATA_RETENTION_DAYS * 24 * 60 * 60 * 1000;
    Object.keys(data.clicks).forEach((key) => {
      if (data.clicks[key].lastSeen < cutoff) {
        delete data.clicks[key];
      }
    });
  }

  // Track clicks on product links
  function trackClick(sourceProduct, targetProduct) {
    const data = getData();
    const key = `${sourceProduct}→${targetProduct}`;

    if (!data.clicks[key]) {
      data.clicks[key] = { count: 0, lastSeen: Date.now() };
    }

    data.clicks[key].count++;
    data.clicks[key].lastSeen = Date.now();
    saveData(data);
  }

  // Calculate affinity scores for current product
  function calculateAffinities(currentProduct) {
    const data = getData();
    const affinities = {};

    Object.keys(data.clicks).forEach((key) => {
      const [source, target] = key.split('→');
      if (source === currentProduct) {
        const score = data.clicks[key].count / 100; // Normalize
        if (score >= MIN_AFFINITY_SCORE) {
          affinities[target] = Math.min(score, 1);
        }
      }
    });

    return affinities;
  }

  // Inject intelligent links into product descriptions
  function injectLinks() {
    if (page.template !== 'product' || !page.product) return;

    const currentProduct = page.product.handle;
    const affinities = calculateAffinities(currentProduct);

    // Get products sorted by affinity
    const topProducts = Object.entries(affinities)
      .sort((a, b) => b[1] - a[1])
      .slice(0, MAX_LINKS_PER_PAGE);

    if (topProducts.length === 0) return;

    // Find suitable injection point (end of description)
    const description = document.querySelector(
      '.product__description, .product-single__description, [itemprop="description"]'
    );
    if (!description) return;

    // Create link container
    const container = document.createElement('div');
    container.className = 'ai-recommended-links';
    container.style.cssText =
      'margin-top: 2rem; padding-top: 1.5rem; border-top: 1px solid #e5e5e5;';

    const heading = document.createElement('p');
    heading.style.cssText =
      'font-size: 0.875rem; font-weight: 600; margin-bottom: 0.75rem; color: #666;';
    heading.textContent = 'Customers also explored:';
    container.appendChild(heading);

    const linkList = document.createElement('div');
    linkList.style.cssText = 'display: flex; flex-wrap: wrap; gap: 0.5rem;';

    topProducts.forEach(([handle]) => {
      const link = document.createElement('a');
      link.href = `/products/${handle}`;
      link.className = 'ai-product-link';
      link.style.cssText =
        'font-size: 0.875rem; color: #0066cc; text-decoration: none; border-bottom: 1px solid transparent; transition: border-color 0.2s;';
      link.textContent = handle.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
      link.dataset.handle = handle;

      link.addEventListener('mouseenter', () => {
        link.style.borderBottomColor = '#0066cc';
      });
      link.addEventListener('mouseleave', () => {
        link.style.borderBottomColor = 'transparent';
      });

      linkList.appendChild(link);
    });

    container.appendChild(linkList);
    description.appendChild(container);
  }

  // Setup click tracking
  function setupTracking() {
    if (page.template !== 'product' || !page.product) return;

    const currentProduct = page.product.handle;

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="/products/"]');
      if (!link) return;

      const href = link.getAttribute('href');
      const match = href.match(/\/products\/([^/?#]+)/);
      if (match && match[1] !== currentProduct) {
        trackClick(currentProduct, match[1]);
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupTracking();
      setTimeout(injectLinks, 500); // Small delay for page to settle
    });
  } else {
    setupTracking();
    setTimeout(injectLinks, 500);
  }
})();
